"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _lang = _interopRequireDefault(require("webmotors-react-pj/i18n/lang"));
var _config = _interopRequireDefault(require("webmotors-react-pj/i18n/config"));
var _default = _ref => {
  let {
    type,
    min,
    max,
    value,
    equal,
    message,
    fnrule
  } = _ref;
  return {
    required: {
      message: _lang.default.webinput.required,
      fn: () => value.trim().length === 0
    },
    email: {
      message: _lang.default.webinput.email,
      fn: () => !/^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,10}|[0-9]{1,10})(\]?)$/.test(value)
    },
    'email-login': {
      message: _lang.default.webinput.emailLogin,
      fn: () => !/^([a-zA-Z0-9_\-.]+)@([a-zA-Z-0-9\-.])+\.[a-z]{1,10}(\.[a-z]{1,3})?$/.test(value)
    },
    tel: {
      message: _lang.default.webinput.tel,
      fn: () => _config.default.webinput.telFn(value)
    },
    mobile: {
      message: _lang.default.webinput.tel,
      fn: () => _config.default.webinput.mobileFn(value)
    },
    date: {
      message: _lang.default.webinput.date,
      fn: () => !/^\w{2}\/\w{2}\/\w{4}$/.test(value)
    },
    'date-short': {
      message: _lang.default.webinput.dateShort,
      fn: () => !/^\d{2}\/\d{2,4}$/.test(value)
    },
    password: {
      message: _lang.default.webinput.password,
      fn: () => !/(?=^.{8,}$)((?=.*[A-Z]{1,})(?=.*[a-z]{1,})(?=.*\d{1,})(?=.*\W{1,}))^.*$/.test(value)
    },
    'password-weakened': {
      message: _lang.default.webinput.passwordWeakened,
      fn: () => !/.{1,}$/.test(value)
    },
    url: {
      message: _lang.default.webinput.url,
      fn: () => !/^https?:\/\/(\w|-)+\.(\w|-)+((\.|\/)[a-z]+(\.[a-z]+(\/\w+)?)?)?.+$/.test(value)
    },
    time: {
      message: _lang.default.webinput.time,
      fn: () => !/^[0-2]\d:[0-5]\d$/.test(value)
    },
    equal: {
      message: _config.default.webinput.equal(document.querySelector(equal)),
      fn: () => {
        const inputEqual = document.querySelector(equal);
        if (inputEqual) {
          return inputEqual.value !== value;
        }
        return false;
      }
    },
    min: {
      message: _config.default.webinput.min(min),
      fn: () => min > Number(value)
    },
    max: {
      message: _config.default.webinput.max(max),
      fn: () => max < Number(value)
    },
    'min-max': {
      message: _config.default.webinput.minMax(min, max),
      fn: () => min > Number(value) && max < Number(value)
    },
    'name-surname': {
      message: _lang.default.webinput.nameSurname,
      fn: () => !/^\D{2,}\s\D{2,}$/.test(value) || /(\\|\||\/|!|@|#|\$|%|&|\*|\(|\)|-|_|=|\+|\[|\]|\{|\}|\?|:|<|>|,|\.)/.test(value)
    },
    zipcode: {
      message: _lang.default.webinput.zipcode,
      fn: _config.default.webinput.zipcodeFn(value)
    },
    plate: {
      message: _lang.default.webinput.plate,
      fn: () => !/^\[A-Z]{3}-\d{4}$/.test(value) || !/^\[A-Z]{3}\d[A-J]\d{2}$/.test(value)
    },
    document: {
      message: _lang.default.webinput.document,
      fn: () => _config.default.webinput.documentFn(value)
    },
    documentCompany: {
      message: _lang.default.webinput.documentCompany,
      fn: () => _config.default.webinput.documentCompanyFn(value)
    },
    renavam: {
      message: _lang.default.webinput.renavam,
      fn: () => {
        const d = value.split('');
        let soma = 0;
        let valor = 0;
        let digito = 0;
        let x = 0;
        for (let i = 5; i >= 2; i--) {
          soma += d[x] * i;
          x++;
        }
        valor = soma % 11;
        if (valor === 11 || valor === 0 || valor >= 10) {
          digito = 0;
        } else {
          digito = valor;
        }
        return digito === d[4];
      }
    },
    custom: {
      message: message,
      fn: () => fnrule(value)
    },
    default: {
      message: _lang.default.webinput.default,
      fn: () => {
        console.log('Input não validado', type);
        return false;
      }
    }
  };
};
exports.default = _default;